import Swiper from 'swiper/bundle'

export default function TextImageSliders () {
  const WRAPPERS = document.querySelectorAll('.mtt-text-image-slider')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const SLIDER = new TextImageSlider(WRAPPERS[i])
    }
  }
}

class TextImageSlider {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.PREV_ARROWS = this.WRAPPER.querySelectorAll('.swiper-button-prev')
    this.NEXT_ARROWS = this.WRAPPER.querySelectorAll('.swiper-button-next')
    this.SWIPER_CONTAINER = this.WRAPPER.querySelector('.swiper-container')
    if (!this.SWIPER_CONTAINER) return

    this.SWIPER = new Swiper(this.SWIPER_CONTAINER, {
      slidesPerView: 1,
      speed: 800,
      spaceBetween: 0,
      freeMode: false,
      watchOverflow: true,
      preloadImages: false,
      lazy: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    })

    if (this.PREV_ARROWS.length > 0) {
      for (let i = 0; i < this.PREV_ARROWS.length; i++) {
        this.PREV_ARROWS[i].addEventListener('click', () => this.SWIPER.slidePrev())
      }
    }
    if (this.NEXT_ARROWS.length > 0) {
      for (let i = 0; i < this.NEXT_ARROWS.length; i++) {
        this.NEXT_ARROWS[i].addEventListener('click', () => this.SWIPER.slideNext())
      }
    }
  }
}
